module.exports = __webpack_public_path__ + "static/media/tra_sto_and_go.e726f277.png";